export default __webpack_public_path__ + "static/media/arrow-down-black.f4de0e5a.svg";